import { AuthActions } from "./Action";

let initialState = {
  AuthData: null,
  Autherror: null,
  isLoggedIn: false,
  errorOccured: false,
  userType: null,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AuthActions.Login_Start:
      return {
        ...initialState,
        AuthData: action.payload,
        Autherror: null,
        isLoggedIn: true,
        userType: action.userType,
      };

    case AuthActions.Login_Failure:
      return {
        ...initialState,
        AuthData: null,
        Autherror: action.payload,
        isLoggedIn: false,
      };
    case AuthActions.Toggle_SnackBar_Open:
      return { ...initialState, errorOccured: true, Autherror: action.payload };
    case AuthActions.Toggle_SnackBar_Close:
      return {
        ...initialState,
        errorOccured: false,
        Autherror: null,
      };
    case AuthActions.Logout_User:
      return {
        AuthData: null,
        Autherror: null,
        isLoggedIn: false,
        errorOccured: false,
      };
    default:
      return state;
  }
};
